
import { Vue } from "vue-class-component";

export default class PlusCircle extends Vue {}
